import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { FormGroup, FormBuilder, Form, AbstractControl } from "@angular/forms";
import { Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "../../../service/auth-service/auth.service";
import { sweetAlert } from "../../../utils/swal";
import { takeUntil } from "rxjs/operators";
import { componentDestroyed } from "@w11k/ngx-componentdestroyed";
import { CorporateService } from "../../corporate-user/corporate-service/corporate-service";
import { EquipmentService } from "../../equipments/equipment-service/equipment.service";
import { LevelOfServiceService } from "../../level-of-service/service/level-of-service.service";
@Component({
  selector: 'app-add-addon',
  templateUrl: './add-addon.component.html',
  styleUrls: ['./add-addon.component.css']
})
export class AddAddonComponent implements OnInit {
  addonForm: FormGroup;
  submitted = false;
  addonId;
  fundingSourceList = [];
  spaceTypeList = [];

  constructor(
    public authService: AuthService,
    private activatedRoute: ActivatedRoute,
    private equipmentService: EquipmentService,
    private fb: FormBuilder,
    private corporateService: CorporateService,
    private levelOfServiceService: LevelOfServiceService,
    private router: Router,
  ) { }

  ngOnInit() {
    this.activatedRoute.params
    .pipe(takeUntil(componentDestroyed(this)))
    .subscribe((params) => {
      this.addonId = params["id"];
      if(this.addonId){
        this.getAddonById();
      }
    });

    this.addonForm = this.fb.group({
      title: ["", Validators.required],
      status: ['active', Validators.required],
      description: [""],
      code: ['',Validators.required],
      fare:[''],
      cooperate: ['',Validators.required],
      spaceType: ['',Validators.required],
      isAddon:[true]
    });
    this.getFundingSourceList();
    this.getSpaceTypes();
  }

  getAddonById(){
    this.equipmentService.getEquipmentbyId(this.addonId)
    .pipe(takeUntil(componentDestroyed(this)))
    .subscribe(
      (data) => {
        if (data) {
          this.addonForm.patchValue(data)
        }
      },
      (err) => {
        sweetAlert("Error", err, "error", "Ok");
      }
    );
  }

  saveAddon() {
    this.submitted = true;
    if (this.addonForm.invalid) {
      return;
    }
      let payload = this.addonForm.value;
      this.equipmentService.saveEquipment(this.addonId,payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.router.navigateByUrl("rates/addons");
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "Ok");
        }
      );
  }

  getFundingSourceList() {
    this.corporateService
      .getCorporateUsers('active')
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data ) {
          this.fundingSourceList = data;
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  getSpaceTypes() {
    this.levelOfServiceService
      .getSpaceTypes({ status: 'active' })
      .subscribe(data => {
        if (data) {
          this.spaceTypeList = data;
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  get form() {
    return this.addonForm.controls;
  }
  onChangeToggle(control: AbstractControl) {
    control.setValue(!control.value);
  }
  onSelectFundingSource(event) {
    if (event) {
      this.addonForm.patchValue({
       cooperate: event
      });
    }
  }


  ngOnDestroy(): void {
  }

}
